"use strict";

import "./feedback-perfomance.scss";

class FeedbackPerfomanceCtrl {
    constructor($mdDialog, DSNDialogService, locals) {
        this.$mdDialog = $mdDialog;
        this.DSNDialogService = DSNDialogService;
        this.locals = locals;
        const imageStar = "/assets/images/starcolorless.svg";
        this.controllerFeedBack = {
            stars: [
                {
                    actived: false,
                    imageStar,
                    tooltip: "Muito ruim"
                },
                {
                    actived: false,
                    imageStar,
                    tooltip: "Ruim"
                },
                {
                    actived: false,
                    imageStar,
                    tooltip: "Regular"
                },
                {
                    actived: false,
                    imageStar,
                    tooltip: "Bom"
                },
                {
                    actived: false,
                    imageStar,
                    tooltip: "Muito bom"
                }
            ]
        };
        this.presentation = {
            comment: "",
            score: ""
        };
    }
    $onInit() {}
    hasStarred() {
        return this.controllerFeedBack.stars.filter((s) => s.actived).length;
    }
    setStars(number) {
        this.presentation.score = number + 1;
        if (this.controllerFeedBack.stars[number].actived) {
            for (let r = number; r < this.controllerFeedBack.stars.length; r++)
                this.controllerFeedBack.stars[r].actived = false;
            return;
        }
        for (let i = 0; i < number + 1; i++)
            this.controllerFeedBack.stars[i].actived = true;
    }
    async sendPerfomance() {
        this.loading = true;
        await this.locals.action.send(this.presentation);
        this.loading = false;
    }
}

angular.module("nucont.shared").controller("FeedbackPerfomanceCtrl", [
    "$mdDialog",
    "DSNDialogService",
    "locals",
    FeedbackPerfomanceCtrl
]);
